<script>
import { mapState } from 'vuex';
import store from './store';
import axios from 'axios';

export default {
	name: 'App',

	props: {
		source: String,
	},

	computed: {
		...mapState('app', [
			'fulfilled_jobs',
			'queued_jobs',
			'app_state'
		]),

		current_job() {
			if (this.fulfilled_jobs.length === 0) {
				return undefined;
			} else {
				return this.fulfilled_jobs[0];
			}
		},

		current_job_status() {
			if (this.current_job === undefined) {
				return 'none';
			} else if (this.current_job.result.statusCode >= 200 && this.current_job.result.statusCode < 400) {
				return 'success';
			} else if (this.current_job.result.statusCode >= 400) {
				return 'failed';
			} else {
				return 'none';
			}
		},
	},
	
	watch: {
		fulfilled_jobs(jobs) {
			if (jobs.length > 0) {
				this.$refs.jobPopup.openPopup();
			}
		},

		app_state(state, old_state) {
			if (!state) return;
			if (old_state && state.status === old_state.status) return;
			
			if (state.status === 'scheduled') {
				this.$refs.appStatePopup.openPopup();
			}
		},
	},

	mounted() {
		this.carbonInitiator();
		setInterval(() => {
			this.readQueue();
		}, 10000);
	},

	methods: {
		carbonInitiator() {
			window.addEventListener('message', (event) => {
				if (event.origin === process.env.VUE_APP_CARBON_DOMAIN && !event.data.type) {
					localStorage.setItem("carbon", true);
				}
			});
		},

		readQueue() {
			const API_ENDPOINT = `${process.env.VUE_APP_API_ENDPOINT}/api/job-queue`;
			this.queued_jobs.forEach((queued_job, i) => {
				axios.get(`${API_ENDPOINT}/${queued_job.job_id}`, { withCredentials: true })
					.then(response => {
						const updatedFulfilled = [...this.fulfilled_jobs, { job_id: queued_job.job_id, options: queued_job.options, result: response.data }];
						store.dispatch('app/setFulfilledJobs', updatedFulfilled);

						const new_list = [...this.queued_jobs];
						new_list.splice(i, 1);
						store.dispatch('app/setQueuedJobs', new_list);
					})
					.catch(() => {
						return;
					})
			});

			store.dispatch("app/setFulfilledJobs", [...this.fulfilled_jobs]);
		},

		removeJobFromList() {
			if (this.current_job.job_id === undefined) return;
			
			const new_list = [...this.fulfilled_jobs];
			new_list.splice(0, 1);
			store.dispatch('app/setFulfilledJobs', new_list);
		},

		handleJobOk() {
			if (this.current_job.job_id === undefined) return;

			const route = this.$router.resolve(
				{
					path: this.current_job.options.path,
					query: this.current_job.options.query,
				}
			);

			window.open(route.href, '_blank');

			this.removeJobFromList();
		},
	},

	/* watch: {
		$route: function () {
			this.$forceUpdate();
		}
	} */
};
</script>

<template>
	<div style="overflow: hidden;">
		<router-view />

		<sust-popup ref="jobPopup"
			size="sm"
			:title="$t(`job_queues.result.${current_job_status}`)"
			@onHide="removeJobFromList()"
			@ok="handleJobOk()"
		>
			<div v-if="current_job !== undefined">
				<div :style="{
						'color': current_job_status === 'failed' ? 'var(--invalid-input)' : null,
						'font-weight': 'bold',
						'font-size': '1.1em',
					}"
				>
					{{ $t(`response_messages.${current_job.result.messageName}`) }}
				</div>
				<div>
					{{ $t(`job_queues.redirect`) }}
				</div>
			</div>
		</sust-popup>

		<sust-popup ref="appStatePopup"
			size="sm"
			:title="$t(`app_state.scheduled_maintenance_title`)"
			:showCancelButton="false"
		>
			<div v-if="app_state" class="flex-all-centered-row">
				{{ $t(`app_state.scheduled_maintenance_text`).replace('#S#', $formatDate(app_state.start_date)).replace('#E#', $formatDate(app_state.end_date)) }}
			</div>
		</sust-popup>
	</div>
</template>

<style lang="scss">
body {
	overflow: hidden;
}
</style>